/* Sourbear memorial-frame page (prototype C, ported to Shopify).
   One choice of 1 or 2 frames for the whole page, add to cart into Horizon's cart drawer,
   gallery pager, review expander, delivery estimate, sticky bar, and the live banner.
   Loaded as a module (snippets/sb-head.liquid). Keep the import static: Shopify minifies theme JS
   on upload and rewrites a dynamic import() into require(), which breaks in the browser. */
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var qty = 1;

  function all(sel, root) { return [].slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- 1 vs 2 frames: the same choice everywhere on the page ---------- */
  function setQty(q) {
    qty = q === 2 ? 2 : 1;
    all('input[data-sb-offer]').forEach(function (r) { r.checked = (+r.value === qty); });
    all('input[data-sb-qty]').forEach(function (i) { i.value = qty; });
    all('[data-sb-price]').forEach(function (el) {
      var v = el.getAttribute('data-p' + qty);
      if (v) el.textContent = v;
    });
    all('[data-sb-qty-label]').forEach(function (el) {
      el.textContent = el.getAttribute(qty === 1 ? 'data-one' : 'data-two');
    });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('input[data-sb-offer]')) setQty(+t.value);
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sb-pick]');
    if (a) setQty(+a.getAttribute('data-sb-pick'));
  });

  /* ---------- add to cart ---------- */
  var toastTimer;
  function toast(msg) {
    var t = document.querySelector('[data-sb-toast]');
    if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.hidden = true; }, 3200);
  }

  function cartSectionIds() {
    // Horizon's cart drawer and cart page re-render from these sections after an add
    return all('cart-items-component[data-section-id]').map(function (el) { return el.dataset.sectionId; });
  }

  // Mirrors Horizon 4.3's product form (assets/product-form.js): announce a CartLinesUpdateEvent
  // from @shopify/events with a promise, post to /cart/add, then resolve the promise with the
  // fresh cart. Horizon's cart drawer, cart icon and cart items listen for that event.
  // Note: read the form's id with getAttribute, because the hidden input name="id" shadows form.id.
  function addToCart(form) {
    var buttons = all('[data-sb-add]');
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    // Horizon declares `Theme` as a global const, so it is not on window.
    var routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add.js';
    var cartUrl = routes.cart_url || '/cart';
    var fd = new FormData(form);
    fd.set('quantity', String(qty));
    var ids = cartSectionIds();
    if (ids.length) fd.append('sections', ids.join(','));
    fd.append('sections_url', window.location.pathname);
    var count = qty, variantId = String(fd.get('id'));

    Promise.resolve().then(function () {
      var deferred = CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: variantId, quantity: count }],
        promise: deferred.promise
      }));
      return fetch(addUrl, { method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          var failed = !!res.status;
          if (failed) toast(res.description || res.message || 'Sorry, that could not be added.');
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              deferred.resolve({
                cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                detail: {
                  items: cart.items, source: 'product-form-component', sourceId: form.getAttribute('id'),
                  itemCount: count, productId: form.getAttribute('data-product-id'),
                  sections: failed ? undefined : res.sections, didError: failed
                }
              });
            });
        })
        .catch(function (err) { deferred.reject(err); throw err; });
    }).catch(function () {
      // Request failed: fall back to a plain form post (goes to the cart page).
      HTMLFormElement.prototype.submit.call(form);
    }).finally(function () {
      buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-sb-form]')) return;
    if (!window.fetch || !window.FormData) return; // plain POST to /cart/add still works
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- per-section setup (runs again when a section reloads in the theme editor) ---------- */
  function initGallery(root) {
    all('[data-sb-gallery]', root).forEach(function (g) {
      if (g.dataset.sbReady) return; g.dataset.sbReady = '1';
      var track = g.querySelector('[data-sb-track]'), pager = g.querySelector('[data-sb-pager]'), cur = -1;
      if (!track || !pager) return;
      var slides = [].slice.call(track.children);
      pager.innerHTML = '';
      if (slides.length < 2) { pager.hidden = true; return; }
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.addEventListener('click', function () { track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); });
        pager.appendChild(b);
      });
      function sync() {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i === cur) return; cur = i;
        [].forEach.call(pager.children, function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      track.addEventListener('scroll', sync, { passive: true }); sync();
    });
  }

  function initReviews(root) {
    all('[data-sb-more]', root).forEach(function (btn) {
      if (btn.dataset.sbReady) return; btn.dataset.sbReady = '1';
      var list = document.getElementById(btn.getAttribute('aria-controls'));
      if (!list) return;
      var label = btn.textContent;
      btn.addEventListener('click', function () {
        var open = list.hidden; list.hidden = !open;
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? 'Show fewer reviews' : label;
      });
    });
  }

  function addBiz(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function initEta(root) {
    var now = new Date();
    all('[data-sb-eta]', root).forEach(function (el) {
      var a = +el.getAttribute('data-min') || 3, b = +el.getAttribute('data-max') || 5;
      el.textContent = fmt(addBiz(now, a)) + ' – ' + fmt(addBiz(now, b));
    });
  }

  // Sticky bar (phones): shows after the main add-to-cart button scrolls above the screen, until the final offer.
  var sticky = null, stickyTicking = false;
  function updSticky() {
    stickyTicking = false;
    if (!sticky) return;
    var main = document.querySelector('[data-sb-main-add]'), fin = document.querySelector('[data-sb-final]');
    var on = !!main && main.getBoundingClientRect().bottom < 0 && (!fin || fin.getBoundingClientRect().top > window.innerHeight * 0.85);
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', String(!on));
    var b = sticky.querySelector('button'); if (b) b.tabIndex = on ? 0 : -1;
  }
  function initSticky() { sticky = document.querySelector('[data-sb-sticky]'); updSticky(); }
  window.addEventListener('scroll', function () { if (!stickyTicking) { stickyTicking = true; requestAnimationFrame(updSticky); } }, { passive: true });
  window.addEventListener('resize', updSticky);

  /* ---------- live banner: the crystal sways from its hook, rainbow spots drift and twinkle,
     the animals stay still and fade dog > cat > rabbit (D-039, D-043) ---------- */
  var PAUSE = '<svg viewBox="0 0 14 14" aria-hidden="true"><rect x="2" y="1.5" width="3.5" height="11" rx="1"/><rect x="8.5" y="1.5" width="3.5" height="11" rx="1"/></svg>';
  var PLAY = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M3 1.5v11l9.5-5.5z"/></svg>';

  function initBanner(root) {
    all('[data-sb-banner]', root).forEach(function (cv) {
      if (cv.dataset.sbReady || !cv.getContext) return; cv.dataset.sbReady = '1';
      var hero = cv.closest('[data-sb-hero]') || root;
      var btn = hero.querySelector('[data-sb-motion]');
      var specEl = hero.querySelector('[data-sb-banner-spec]');
      if (!specEl) return;
      var spec = JSON.parse(specEl.textContent);
      var plateUrls = cv.getAttribute('data-plates').split('|'), crystalUrls = cv.getAttribute('data-crystals').split('|'), spotsUrl = cv.getAttribute('data-spots');
      var ctx = cv.getContext('2d'), plates, crystals, atlas, off, octx, T = 19.5, swayP = 4.875;
      var SEG = 6.5, HOLD = 5, FADE = 1.5, AMP = 1.25 * Math.PI / 180;
      var FIRST = 3; // the dog stays 3 s longer before the first fade (dog first, owner 2026-10-12)
      var playing = !reduce, visible = true, raf = 0, elapsed = 0, last = 0, ready = false;

      function load(src) { return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
      function setBtn() {
        if (!btn) return;
        btn.setAttribute('aria-label', playing ? 'Pause animation' : 'Play animation');
        btn.setAttribute('aria-pressed', String(!playing));
        btn.innerHTML = playing ? PAUSE : PLAY;
      }
      function draw(time) {
        var t = time % T;                         // motion clock: crystal sway, rainbow spots
        var st = Math.max(0, time - FIRST) % T;   // slide clock: dog > cat > rabbit
        var s = Math.sin(2 * Math.PI * t / swayP), th = AMP * s, n = plates.length;
        var seg = Math.floor(st / SEG) % n, local = st - Math.floor(st / SEG) * SEG, list = [[seg, 1]];
        if (local > HOLD) { var w = (local - HOLD) / FADE; w = w * w * (3 - 2 * w); list.push([(seg + 1) % n, w]); }
        var c = spec.crystal, h = spec.heart, pv = spec.pivot;
        ctx.globalCompositeOperation = 'source-over';
        list.forEach(function (it, idx) {
          ctx.globalAlpha = idx === 0 ? 1 : it[1];
          ctx.drawImage(plates[it[0]], 0, 0, spec.w, spec.h);
          octx.globalCompositeOperation = 'source-over'; octx.clearRect(0, 0, off.width, off.height);
          octx.drawImage(crystals[it[0]], 0, 0, c.w, c.h);
          var bx = h[0] + (h[2] - h[0]) * (0.5 + 0.6 * s) - c.x, g = octx.createLinearGradient(bx - 34, 0, bx + 34, 0);
          g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(0.5, 'rgba(255,255,255,.32)'); g.addColorStop(1, 'rgba(255,255,255,0)');
          octx.globalCompositeOperation = 'source-atop'; octx.fillStyle = g; octx.fillRect(0, h[1] - c.y, off.width, h[3] - h[1]);
          ctx.save(); ctx.translate(pv[0], pv[1]); ctx.rotate(th); ctx.translate(-pv[0], -pv[1]); ctx.drawImage(off, c.x, c.y); ctx.restore();
        });
        ctx.globalCompositeOperation = 'lighten';
        spec.spots.forEach(function (p) {
          ctx.globalAlpha = p.peak * (0.5 + 0.5 * Math.sin(2 * Math.PI * t / (T / p.tw) + p.ph));
          ctx.drawImage(atlas, p.sx, 0, p.sw, p.sw, p.x + p.k * s * Math.cos(p.dir) - p.sw / 2, p.y + p.k * s * Math.sin(p.dir) * 0.6 - p.sw / 2, p.sw, p.sw);
        });
        ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
      }
      function frame(ts) {
        raf = 0;
        if (!playing || !visible || document.hidden || !cv.isConnected) { last = 0; return; }
        if (last) elapsed += (ts - last) / 1000;
        last = ts; draw(elapsed); raf = requestAnimationFrame(frame);
      }
      function kick() { if (ready && !raf && playing && visible && !document.hidden) { last = 0; raf = requestAnimationFrame(frame); } }
      // Start again from the dog whenever the banner comes back into view, the tab comes back, or the page is restored.
      function restart() { elapsed = 0; last = 0; if (ready) draw(0); }
      if (btn) btn.addEventListener('click', function () { playing = !playing; setBtn(); kick(); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) restart(); kick(); });
      window.addEventListener('pageshow', function (e) { if (e.persisted) { restart(); kick(); } });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { var was = visible; visible = e[0].isIntersecting; if (visible && !was) restart(); kick(); }).observe(cv);
      }
      setBtn();
      Promise.all([Promise.all(plateUrls.map(load)), Promise.all(crystalUrls.map(load)), load(spotsUrl)]).then(function (r) {
        plates = r[0]; crystals = r[1]; atlas = r[2];
        T = SEG * plates.length; swayP = T / Math.max(1, Math.round(T / 4.6));
        off = document.createElement('canvas'); off.width = Math.ceil(spec.crystal.w); off.height = Math.ceil(spec.crystal.h); octx = off.getContext('2d');
        ready = true; draw(0); kick();
      }).catch(function () { /* the poster image stays as the banner */ });
    });
  }

  function init(root) {
    initGallery(root); initReviews(root); initEta(root); initBanner(root); initSticky();
    setQty(qty);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
